import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function Idempotency() {
    return (
        <TopicLayout
            title="Idempotency"
            intro="A retried request carrying the same idempotency key must produce the same outcome as the original, not a second one. The server recognizes the key and returns the stored result instead of repeating the effect."
            diagram={
                <Diagram viewBox="0 0 560 130">
                    <text x={280} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>A retry with the same key is deduplicated</text>
                    <Box x={20} y={35} width={90} height={55} label="Client"/>
                    <Box x={230} y={35} width={90} height={55} label="Server" accent/>
                    <Box x={430} y={35} width={115} height={55} label="Key store" sublabel="(idempotency)"/>

                    <Arrow x1={110} y1={48} x2={230} y2={48} label="request #1"/>
                    <Arrow x1={110} y1={64} x2={230} y2={64} label="retry (same key)" dashed/>
                    <Arrow x1={320} y1={48} x2={430} y2={48} label="check/store key"/>
                    <Arrow x1={430} y1={64} x2={320} y2={64} label="cached result" muted/>
                    <Arrow x1={230} y1={80} x2={110} y2={80} label="same result, both times"/>
                </Diagram>
            }
            useWhen={[
                'Any state-changing operation may be retried because of timeouts, network failures or at-least-once delivery. A retry of “charge $50” must not create a second charge.'
            ]}
            tradeOff="Give each logical operation a unique key and atomically store the key with its outcome before acknowledging success. Concurrent requests for the same key must coordinate instead of both running. Define an expiry policy, bind the key to a request fingerprint so it cannot be reused with a different payload, and return the saved result for a valid duplicate."
            ruleOfThumb="Treat idempotency as a default requirement for retriable state changes, and make the idempotency record part of the same atomic boundary as the change."
        />
    )
}
